import { Box, FlexLayout, H4 } from '@deity/falcon-ui';
import { mergeEndpointAndService } from '@deity-io/di-data-flows-editor';
import { Checkbox } from '@deity-io/portal-ui';
import { EndpointContext } from 'contexts/EndpointContext';
import { useContext, useState } from 'react';
import ReactJson from 'react-json-view';

export const EndpointConfigJSON = () => {
  const ctx = useContext(EndpointContext);
  const [expand, setExpand] = useState(true);
  const data = expand
    ? mergeEndpointAndService(ctx?.state.schema, ctx?.state.service?.schema)
    : ctx?.state.schema || {};

  return (
    <FlexLayout p="xl">
      <H4 mb="lg" fontWeight="semiBold" fontSize="xl">
        Endpoint configuration
      </H4>
      <Box width="full">
        <Checkbox
          checked={expand}
          onChange={() => setExpand(!expand)}
          label="Show full configuration (including service)"
        />
      </Box>
      <Box width="full">
        <ReactJson src={data} name={null} theme="solarized" />
      </Box>
    </FlexLayout>
  );
};
